// only Mixpanel and Kochava
export enum GtmEventMap {
  IDENTIFY = 'Identify',
  SMART_LINK_TRIGGERED = 'Smart Link Triggered',
  ACCOUNT_LOGGED_OUT = 'Account Logged out',
  ACCOUNT_LOGGED_IN = 'Account Logged in',
  EXPLORE_TAB_VIEWED = 'Explore Tab Viewed',
  CATEGORY_VIEWED = 'Category Viewed',
  SUB_CATEGORY_VIEWED = 'Sub Category Viewed',
  BRANCH_PAGE_VIEWED = 'Branch Page Viewed',
  PRODUCT_DETAIL_VIEWED = 'Product Detail Viewed',
  TIME_SELECTION_STARTED = 'Time Selection Started',
  TIME_SELECTION_COMPLETED = 'Time Selection Completed',
  ORDER_CREATED = 'Order Created',
  HOME_BANNER_CLICKED = 'Home Banner Clicked',
  REGION_CHANGED = 'Region Changed',
  LIST_SORT_APPLIED = 'List Sort Applied',
  LIST_FILTER_APPLIED = 'List Filter Applied',
  BOOKING_TAB_VIEWED = 'Booking Tab Viewed',
  PROMOCODE_PAGE_VIEWED = 'Promocode Page Viewed',
  SEARCH_QUERY_SENT = 'Search Query Sent',
  CAMPAIGN_PAGE_VIEWED = 'Campaign Page Viewed',
  VIEW_ITEM_LIST = 'view_item_list',
  HOME_BRAND_CLICKED = 'Home Brand Clicked',
  FUNKI_PAGE_VIEWED = 'Funki Page Viewed',
}

/**
 * GTM Source values for product attribution tracking.
 * These hardcoded strings are defined in the spec document:
 * @see https://docs.google.com/document/d/1-ZZUwVsAIfOdg7sucDZifM_k3v7FiaeYuHSpzGxFXKw/edit?tab=t.0
 */
export enum GtmSource {
  CATEGORY_LIST = 'category list',
  TAG_LIST = 'tag list',
  SEARCH_RESULT_LIST = 'search result list',
  FLASH_SALES_LIST = 'flash sales list',
  HOME_HOT_RECOMMENDATION = 'home hot recommendation',
  HOME_PERSONALIZED_RECOMMENDATION = 'home personalized recommendation',
  HOME_FLASH_SALES = 'home flash sales',
  HOME_BANNER = 'home banner',
  PRODUCT_DETAIL_OTHER_SIMILAR = 'product detail other similar',
  PRODUCT_DETAIL_SAME_BRANCH = 'product detail same branch',
  BRANCH_PAGE = 'branch page',
  NEWS = 'news',
  PROMO_CODE = 'promo code',
  ORDER_DETAIL = 'order detail',
  LINK = 'link',
  FLASH_SALES_PIN_LIST = 'flash sales pin list',
  GIFT_BOX_LIST = 'gift box list',
  FUNKI_CHATBOT = 'funki chatbot',
  SAVED_PRODUCT_PAGE = 'saved product page',
  RECENTLY_BROWSED = 'recently browsed',
  MEMBER_RECENTLY_BROWSED = 'member recently browsed',
  HOME_LAST_MINUTE = 'home last minute',
  LAST_MINUTE_LIST = 'last minute list',
  LAST_MINUTE_PIN_LIST = 'last minute pin list',
  HOME_DISCOUNT = 'home discount',
  DISCOUNT_LIST = 'discount list',
  DISCOUNT_PIN_LIST = 'discount pin list',
  ELITE_REDEMPTION = 'elite redemption',
}

/**
 * Keyword source for Search Query Sent event.
 * Tracks how the user selected the search keyword.
 */
export enum SearchKeywordSource {
  POPULAR = 'popular',
  HISTORY = 'history',
}

/**
 * Search Query Sent event source — where the user initiated the search.
 * @see https://docs.google.com/document/d/1-ZZUwVsAIfOdg7sucDZifM_k3v7FiaeYuHSpzGxFXKw/edit?tab=t.0#heading=h.a2sbs35gs5s9
 */
export enum SearchEventSource {
  HOME = 'home',
  CATEGORY_LIST = 'category list',
  FLASH_SALES_LIST = 'flash sales list',
}

/**
 * Search Query Sent UI Component — which search bar the user interacted with.
 * Only applicable on restaurant/bar/takeout category pages.
 */
export enum SearchUIComponentLabel {
  MAIN = 'search bar main',
  STICKY = 'search bar sticky',
}
